import dataModel from '../../models/DataModel.js';
import projectsService from '../../services/projectsService';
import AOCollection from './AOCollection';
import ReduxConstants from '../../constants/ReduxConstants.js';

export const location_projects_root = {
  project: {
  },
};

export default class LocationProjectsNavCollection extends AOCollection {
  constructor(location_id, perPage, searchString, userId, companyId, subKey, filter) {
    super({
      name: ReduxConstants.LOCATION_PROJECTS_NAV,
      collectionType: ReduxConstants.PROJECT,
      perPage, 
      searchString,
      userId,
      companyId, 
      subKey,
      filter,
    });

    this.location_id = location_id;
  }

  static build(location_id, perPage, searchString, userId, companyId, subKey, filter = {}) {
    let collection = new LocationProjectsNavCollection(location_id, perPage, searchString, userId, companyId, subKey, filter);
    if (perPage) {
      collection.page = 0;
    }
    
    collection._recordState = '';
    let collectionData = dataModel.collectionsDAO.findCollection(collection.getKey());
    dataModel.collectionsDAO.setCollection(collection.getKey(), collectionData ? collectionData : collection.getData(), collection.getCollectionType());

    // for now not using data from store
    // let collectionData = dataModel.collectionsDAO.findCollection(collection.getKey())
    // if (!collectionData) {
    //   collection._recordState = ''
    //   dataModel.collectionsDAO.setCollection(collection.getKey(), collection.getData(), collection.getCollectionType())
    // }
    // else {
    //   collection._filter = collectionData._filter
    //   collection.ids = collectionData.ids
    //   collection.page = collectionData.page
    //   collection.perPage = collectionData.perPage
    //   collection.meta = collectionData.meta
    // }

    return collection;
  }

  async fetchByIds(projectIds, options = {}) {
    if (!options.recordDescriptor) {
      options.recordDescriptor = location_projects_root;
    }
    if (dataModel.isOffline) {
      return this.getDenormalizedCollection(options);
    }
    else {

      if (!projectIds || projectIds.length == 0) {
        return { projects: [] };
      }
      let serviceCall = projectsService.getProjectsByIds.bind(this, projectIds, options, this.location_id);
      let newCollection = await this._fetchData(serviceCall, options, true);

      newCollection.totalProjects = newCollection.meta ? newCollection.meta.total_projects : 0;
      return newCollection;
    }
  }

  async fetchNext(pageOverride, options = {}, prefetchCallback) {
    if (!options.recordDescriptor) {
      options.recordDescriptor = location_projects_root;
    }
    if (dataModel.isOffline) {
      return this.getDenormalizedCollection(options);
    }
    else {
      if (pageOverride) {
        this.page = pageOverride;
      }
      else this.page++;

      let serviceCall = projectsService.search_location_projects.bind(this, this._filter.searchString, this._filter && this._filter.project_type ? this._filter.project_type.id : '', this._filter ? this._filter.state : '', this.location_id, null, this._filter ? this._filter.statuses : null, this._filter && this._filter.showArchived ? true : null, null, this.page, this.perPage, options);
      let newCollection = await this._fetchData(serviceCall, options, true, null, prefetchCallback);

      newCollection.totalProjects = newCollection.meta ? newCollection.meta.total_projects : 0;
      return newCollection;
    }
  }

  async fetchCurrent(shouldPaginate = true, options = {}, prefetchCallback) {
    if (!options.recordDescriptor) {
      options.recordDescriptor = location_projects_root;
    }
    // let collection = this.findCollection()

    let page = null;
    let perPage = null;
    
    // Get everything
    // if (shouldPaginate) {
    //   page = 1
    //   if (collection && collection.perPage) {
    //     perPage = Math.max(this.perPage, collection.ids.length)
    //   }
    // }

    const { searchString, project_type, state, showArchived, statuses } = this._filter;
    let serviceCall = projectsService.search_location_projects.bind(this, searchString, project_type ? project_type.id : '', state, this.location_id, null, statuses, !!showArchived, null, page, perPage, options);
    
    let newCollection = await this._fetchData(serviceCall, options, false, null, prefetchCallback);
  
    newCollection.totalProjects = newCollection.meta ? newCollection.meta.total_projects : 0;
    return newCollection;
  }
}



// WEBPACK FOOTER //
// ./src/dao/collections/LocationProjectsNavCollection.js